import { Injectable } from '@angular/core';
import { ToastComponent, ToastModel } from '@syncfusion/ej2-angular-notifications';

@Injectable({ providedIn: 'root' })
export class ToastService {
    private toastReference: ToastComponent | null = null;

    registerToast(toast: ToastComponent): void {
        this.toastReference = toast;
    }

    show(message: string, type: 'success' | 'danger' | 'warning' = 'success', title?: string): void {
        if (this.toastReference) {
            this.toastReference.show({
                title: title || (type === 'success' ? 'Successo' : 'Errore'),
                content: message,
                position: { X: 'Right', Y: 'Bottom' },
                cssClass: `e-toast-${type}`
            });
        }
    }

    showSuccess(msg: string, title?: string): void {
      this.show(msg, 'success', title);
    }

    showError(msg: string, title?: string): void {
      this.show(msg, 'danger', title);
    }
}